/* Orion UGC video rail. Poster-first: the <video> element exists only inside
   a <template> until first tap. First tap plays muted; second tap toggles
   sound. Off-screen cards pause via IntersectionObserver. */
(() => {
  class OrionVideoRail extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-o-video-card]')];
      this.observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              const vid = en.target.querySelector('video');
              if (vid && !en.isIntersecting) vid.pause();
            });
          }, { threshold: 0.25 })
        : null;
      this.cards.forEach((card) => {
        const btn = card.querySelector('[data-o-video-play]');
        if (!btn || !card.querySelector('[data-o-video-template]')) {
          if (btn) btn.hidden = true;
          return;
        }
        btn.addEventListener('click', () => this.activate(card));
        if (this.observer) this.observer.observe(card);
      });
    }

    activate(card) {
      let video = card.querySelector('video');
      if (!video) {
        const tpl = card.querySelector('[data-o-video-template]');
        card.insertBefore(tpl.content.cloneNode(true), tpl);
        video = card.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.play().catch(() => { /* poster remains */ });
        card.classList.add('is-playing');
        /* pause any other playing card */
        this.cards.forEach((c) => {
          if (c !== card) {
            const v = c.querySelector('video');
            if (v) v.pause();
          }
        });
        return;
      }
      if (video.paused) {
        video.play().catch(() => { /* ignore */ });
        card.classList.add('is-playing');
      } else {
        video.muted = !video.muted;
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('orion-video-rail')) {
    customElements.define('orion-video-rail', OrionVideoRail);
  }
})();
